import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLogin } from "../../context/LoginProvider";
import "./ProfileSummary.css";
import Navbar from "../Navbar";
import cupidImage from "../../assets/cupid.png";

const getRelationshipTypeLabel = (type) => {
  const labels = {
    "friendship": "Friendship",
    "dating": "Dating", 
    "serious_relationship": "Serious Relationship",
    "casual": "Casual",
    "networking": "Networking",
    "any": "Open to Anything"
  };
  return labels[type] || type;
};

const ProfileSummary = () => {
  const { isLoggedIn, userData, guestData } = useLogin();
  const navigate = useNavigate();
  const [isStarting, setIsStarting] = useState(false);

  const currentUser = isLoggedIn ? userData : guestData;

  const handleStartMatching = () => {
    setIsStarting(true);
    setTimeout(() => {
      navigate("/chat", { replace: true });
    }, 1000);
  };

  const handleEditProfile = () => {
    if (isLoggedIn) {
      navigate("/profile", { replace: true });
    } else {
      navigate("/guest-info", { replace: true });
    }
  };

  const handleEditInterests = () => {
    localStorage.setItem("editingInterests", "true");
    console.log("[ProfileSummary] Setting editingInterests flag and navigating to cupid page");
    navigate("/cupid", { replace: true });
  };

  return (
    <>
      <Navbar isHomePage={false} />
      <div className="profile-summary-page">
        <div className="profile-summary-container">
          <div className="avatar-section">
            <img src={cupidImage} alt="Sol" className="summary-avatar" />
            <div className="avatar-message">
              <h2>You're all set!</h2>
              <p>Here's your complete profile before we find your perfect match</p>
            </div>
          </div>

          <div className="profile-details-card">
            <div className="card-header">
              <h3>Your Profile Summary</h3>
              <span className="user-type-badge">
                {isLoggedIn ? "Registered User" : "Guest User"}
              </span>
            </div>

            <div className="profile-details">
              <div className="detail-section">
                <div className="detail-group">
                  <label>Name</label>
                  <div className="detail-value">
                    <span>{currentUser.name}</span>
                    <button 
                      className="edit-btn" 
                      onClick={handleEditProfile}
                      title="Edit profile"
                    >
                      ✏️
                    </button>
                  </div>
                </div>

                <div className="detail-group">
                  <label>Age</label>
                  <div className="detail-value">
                    <span>{currentUser.age} years old</span>
                    <button 
                      className="edit-btn" 
                      onClick={handleEditProfile}
                      title="Edit profile"
                    >
                      ✏️
                    </button>
                  </div>
                </div>

                <div className="detail-group">
                  <label>Country</label>
                  <div className="detail-value">
                    <span>{currentUser.country}</span>
                    <button 
                      className="edit-btn" 
                      onClick={handleEditProfile}
                      title="Edit profile"
                    >
                      ✏️
                    </button>
                  </div>
                </div>

                <div className="detail-group">
                  <label>Looking For</label>
                  <div className="detail-value">
                    <span>
                      {currentUser.relationshipType ? 
                        getRelationshipTypeLabel(currentUser.relationshipType) 
                        : 'Not specified'
                      }
                    </span>
                    <button 
                      className="edit-btn" 
                      onClick={handleEditProfile}
                      title="Edit profile"
                    >
                      ✏️
                    </button>
                  </div>
                </div>
              </div>

              <div className="interests-section">
                <div className="interests-header">
                  <label>Your Interests</label>
                  {isLoggedIn && (
                  <button 
                    className="edit-btn" 
                    onClick={handleEditInterests}
                    title="Edit interests"
                  >
                    ✏️
                  </button>
                  )}
                </div>
                <div 
                  className="interests-list" 
                  onClick={isLoggedIn ? handleEditInterests : handleEditProfile} 
                  title={isLoggedIn ? "Click to edit interests" : "Click to edit profile"}
                >
                  {currentUser.interests && currentUser.interests.length > 0 ? (
                    currentUser.interests.map((interest, index) => (
                      <span key={index} className="interest-tag">
                        {interest}
                      </span>
                    ))
                  ) : (
                    <span className="no-interests">
                      {isLoggedIn ? "Click to add interests" : "Update your interests in profile"}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="action-buttons">
              <button 
                className="edit-profile-btn" 
                onClick={handleEditProfile}
              >
                Edit Profile
              </button>
              {isLoggedIn && (
              <button 
                className="edit-interests-btn" 
                onClick={handleEditInterests}
              >
                Edit Interests
              </button>
              )}
              <button 
                className={`start-matching-btn ${isStarting ? 'starting' : ''}`}
                onClick={handleStartMatching}
                disabled={isStarting}
              >
                {isStarting ? (
                  <>
                    <span className="loading-spinner"></span>
                    Finding Matches...
                  </>
                ) : (
                  <>
                    <span className="heart-icon">💕</span>
                    Start Finding Matches
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileSummary; 